import { getStore } from '@/store'
import { getSearchParams } from '@/utils'

import { qrNameAtom } from '../contentFormSections'
import { GENERATOR_SEARCH_PARAM, QR_TYPE } from '../generatorTypes'
import { qrDesignAtom } from '../pages/QrDesignFormPage/qrDesignState'
import { getQrPasswordPublishValue } from '../pages/QrDesignFormPage/qrPasswordUtils'
import { qrCodesApi } from '../services/shared'
import { getQrDataToEncode } from './buildQrLandingUrl'
import { QR_TYPE_TO_CONTENT_ATOM } from './qrTypeToContentAtom'
import { withScannableLogo } from './withScannableLogo'

export const publishEditedQr = async (qrType: QR_TYPE) => {
	const searchParams = getSearchParams()
	const qrId = searchParams.get('id')
	if (!qrId) {
		throw new Error('Missing QR ID')
	}
	const targetId = searchParams.get(GENERATOR_SEARCH_PARAM.Target)
	if (!targetId) {
		throw new Error('Missing target QR ID')
	}
	const contentAtom = QR_TYPE_TO_CONTENT_ATOM[qrType]
	const content = getStore().get(contentAtom)
	const qrDesign = await withScannableLogo(
		getStore().get(qrDesignAtom),
		async () => {
			const {
				data: { uri },
			} = await qrCodesApi.getQr(targetId)
			return getQrDataToEncode({ qrUri: uri, qrContent: content })
		},
	)
	await qrCodesApi.publishQrPreview({
		targetId,
		previewQRCodeId: qrId,
		qrCodeDto: {
			name: getStore().get(qrNameAtom) || '',
			content,
			qrDesign,
		},
		password: getQrPasswordPublishValue(),
	})
}
